<template>
  <v-container fluid class="equipmentList-management mt-4 px-1">
    <v-row>


      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>รายการวัสดุอุปกรณ์</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + equipmentLists.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="3">

                  <v-select
                      @change="searchData"
                      v-model="search_data.item_type_master_code"
                      :items="e_i_tem_type_master_combo"
                      item-text="item_type_master_name"
                      item-value="item_type_master_code"
                      label="ประเภทอุปกรณ์"
                      clearable=""
                  ></v-select>


                </v-col>


                <v-col class="d-flex" cols="12" sm="3">

                  <v-menu
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          @change="clearableDate('start')"
                          v-model="dateFormatted3"
                          label="วันที่ยืม"
                          hint="วัน/เดือน/พ.ศ."
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        @change="searchData"
                        v-model="date3"
                        :first-day-of-week="1"
                        locale="th"
                        @input="menu3 = false"
                    ></v-date-picker>
                  </v-menu>


                </v-col>


                <v-col class="d-flex" cols="12" sm="3">

                  <v-menu
                      v-model="menu4"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          @change="clearableDate('end')"
                          v-model="dateFormatted4"
                          label="วันที่คืน"
                          hint="วัน/เดือน/พ.ศ."
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        @change="searchData"
                        v-model="date4"
                        :first-day-of-week="1"
                        locale="th"
                        @input="menu4 = false"
                    ></v-date-picker>
                  </v-menu>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      append-icon="mdi-magnify"
                      class="search"
                      v-model="search"
                      label="ค้นหา (Search)"
                  ></v-text-field>
                </v-col>

              </v-row>

            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :options="options"
                :items="equipmentLists"
                :search="search"
                sort-by="item_id">
              <template v-slot:top>


                <template>
                  <v-btn v-if="currentUser.role=='admin'"
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                      :disabled="currentUser.role!='admin'"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>

              <template v-slot:item.item_h_image="{ item }">

                <v-avatar tile>
                  <img
                      :src="baseURLStorage+item.item_h_image"
                      :alt="item.item_name"
                  >
                </v-avatar>
                <v-avatar tile v-if="item.switch_lang=='Y'">
                  <img
                      :src="baseURLStorage+item.news_h_image_en"
                      :alt="item.item_name"
                  >
                </v-avatar>

              </template>

              <template v-slot:item.available_quantity="{ item }">
                <span v-if="date3!=''||date4!=''"> {{item.available_quantity}}  </span>
                <span v-else> {{item.item_quantity}}  </span>
              </template>


              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">

                <v-btn
                    @click="gotoBR"
                    small
                    class="mr-3 button-shadow"
                    color="warning"
                    :disabled="item.active!='Y' || item.item_quantity*1==0"
                >ยืม
                </v-btn>


                <v-btn v-if="currentUser.role=='admin'"
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                    :disabled="currentUser.role!='admin'"
                >แก้ไข
                </v-btn>


                <v-btn v-if="currentUser.role=='admin'"
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                    :disabled="currentUser.role!='admin'"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">
                  <v-text-field
                      v-model="editForm.item_id"
                      label="รหัสวัสดุอุปกรณ์"
                      required
                      disabled
                      v-if="state=='addForm'"
                  ></v-text-field>

                  <v-text-field
                      v-model="editForm.item_id"
                      :rules="editForm.textReqRules.concat(editForm.orderRules)"
                      label="รหัสวัสดุอุปกรณ์"
                      required
                      readonly
                      disabled
                      v-else
                  ></v-text-field>

                </v-col>


              </v-row>

              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="6">

                  <v-select
                      v-model="editForm.item_type_master_code"
                      :items="e_i_tem_type_master_combo"
                      :rules="editForm.textReqRules"
                      item-text="item_type_master_name"
                      item-value="item_type_master_code"
                      label="ประเภทอุปกรณ์"
                      clearable=""
                      required
                  ></v-select>


                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      v-model="editForm.item_name"
                      :rules="editForm.textReqRules"
                      label="ชื่อประเภทวัสดุอุปกรณ์"
                      required
                  ></v-text-field>


                </v-col>
              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='addForm'">

                  <v-col v-if="editForm.preview==''">

                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                      <v-col
                          class="text-subtitle-1 text-center"
                          cols="12"
                      >
                        เลือกไฟล์เพื่อแสดงผล
                      </v-col>
                      <v-col cols="6">
                        <v-progress-linear
                            color="deep-purple accent-4"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                      </v-col>
                    </v-row>

                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='addForm'">

                  <v-file-input
                      @change="previewImage"
                      v-model="editForm.avatarFile"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.imageRules)"
                      accept="image/*"
                      placeholder="ภาพประกอบหัวข้อ (TH)"
                      prepend-icon="mdi-file-image"
                      label="ภาพประกอบหัวข้อ (TH) "
                  ></v-file-input>


                </v-col>


                <!--*************************************************-->

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='editForm'">

                  <v-col v-if="editForm.preview==''">

                    <v-img
                        :src="baseURLStorage+editForm.avatarFileOld"
                        :alt="editForm.item_name"
                        style="max-width: 100%"
                    ></v-img>

                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='editForm'">

                  <v-file-input
                      @change="previewImage"
                      v-model="editForm.avatarFile"
                      show-size
                      chips
                      :rules="editForm.imageRules"
                      accept="image/*"
                      placeholder="ภาพประกอบหัวข้อใหม่ (TH)"
                      prepend-icon="mdi-file-image"
                      label="ภาพประกอบหัวข้อใหม่ (TH) "
                  ></v-file-input>


                </v-col>

                <!--*************************************************-->


              </v-row>


              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="4">

                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>

                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>

    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import dataFormatter from "@/use/dataFormatter";
import axios from "axios";


export default {
  name: 'EquipmentList',
  data() {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      modal: false,
      menu2: false,
      date3: '',
      date4: '',
      dateFormatted3: '',
      dateFormatted4: '',
      menu3: false,
      menu4: false,

      state: 'index',
      baseURLApi: config.baseURLApi,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      search: '',
      search_data: {
        item_type_master_code: "",
        start_date: '',
        end_date: '',
      },
      selected: [],
      headers: [
        {
          text: 'รหัสวัสดุอุปกรณ์',
          align: 'start',
          value: 'item_id',
        },
        {
          text: 'ภาพ',
          value: 'item_h_image',
        },

        {text: 'ประเภทวัสดุอุปกรณ์', value: 'item_type_master_name'},
        {text: 'ชื่อรายการ', value: 'item_name'},
        {text: 'จำนวนทั้งหมด', value: 'item_quantity'},
        {text: 'จำนวนที่พร้อมให้บริการ', value: 'available_quantity'},
        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      options: {
        sortBy: ["item_id"],
        sortDesc: [true]
      },
      e_i_tem_type_master_combo: [],

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        codeRules: validateRules.codeRules,
        textReqRules: validateRules.textReqRules,
      },
      temp_data: null,
    }
  },
  components: {},
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('equipment_lists', ['equipmentLists', "isReceiving", "isDeleting", "idToDelete", "equipmentListMessage", "isUpdating", "errorMessage"]),

    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
    dataFormatter() {
      return dataFormatter;
    },

    //Date Picker Format
    computedDateFormatted() {
      return this.formatDate(this.date)
    },

    //Date Picker Format
    computedDateFormatted3() {
      return this.formatDate(this.date3)
    },

    //Date Picker Format
    computedDateFormatted4() {
      return this.formatDate(this.date4)
    },

    computedDateMonthFormatted() {
      return this.formatDateMonth(this.datemonth)
    },
    //getDataUserLogin
    ...mapState('auth', {
      currentUser: (state) => state.currentUser,
    }),
    ...mapState({
      data: (state) => state.usersForm.data,
    }),
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    equipmentListMessage() {

      if (this.equipmentListMessage !== '') {
        this.notification = this.equipmentListMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    },
    //Date Picker Format
    date() {
      this.dateFormatted = this.formatDate(this.date)
    },
    date3() {
      this.dateFormatted3 = this.formatDate(this.date3)
    },
    date4() {
      this.dateFormatted4 = this.formatDate(this.date4)
    },
    datemonth() {
      this.datemonthFormatted = this.formatDateMonth(this.datemonth)
    },
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getEquipmentListsRequest(this.search_data);
    this.getEItemTypeMaster();
    this.resetValue();
  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('equipment_lists',
        [
          "getEquipmentListsRequest",
          "deleteEquipmentListRequest",
          "updateEquipmentListRequest",
          "createEquipmentListRequest"
        ]
    ),
    ...mapActions('web_con_new_images', ["getWeb_con_new_imagesRequest"]),

    resetValue() {
      this.editForm = {} //set null all value
      this.editForm = {
        valid: true,
        orderRules: validateRules.orderRules,
        textReqRules: validateRules.textReqRules,
        imageRules: validateRules.fileSingleRules(3),
        item_id: null,
        item_type_master_code: '',
        item_name: '',
        active: 'N',
        preview: '',
        avatarFile: null,
        avatarFileOld: null,
        item_h_image: null
      }
    },
    async getEItemTypeMaster() {

      try {
        await axios.post(config.baseURLApi + '/combo/' + 'eItemTypeMaster', '', {
          headers: {},
        }).then(res => {
          this.e_i_tem_type_master_combo = res.data;
        });
      } catch (e) {
        this.showSnackbar(e);
      }

    },


    previewImage: function (event) {
      event == null ? this.editForm.preview = '' : this.editForm.preview = URL.createObjectURL(event)
    },

    addItem() {
      this.editedIndex = -1 //index = -1 add
      this.resetValue();
      this.editForm.active = 'Y';
      this.editForm.item_id = 'AUTO'
      this.state = 'addForm';
    },
    editItem(item) {
      this.resetValue();
      this.editedIndex = this.equipmentLists.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.avatarFileOld = item.item_h_image;
      this.editForm.item_type_master_code = item.item_type_master_code;
      this.editForm.item_name = item.item_name;
      this.editForm.item_id = item.item_id * 1;
      this.editForm.active = item.active;
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteEquipmentListRequest({item_id: item.item_id})

    },

    close() {

      if (this.errorMessage == false || this.equipmentListMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {


      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.equipmentLists[this.editedIndex], this.editForm)
            :
            this.updateEquipmentListRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.equipmentLists.push(this.editForm)
            :
            this.createEquipmentListRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    async reset() {
      await this.$refs.form.reset()
      this.resetValue()
    },
    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },


    //Date Picker Format

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${(year) * 1 + 543}`
    },
    formatDateMonth(date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${(year) * 1 + 543}`
    },

    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    parseDateMonth(date) {
      if (!date) return null
      const [month, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}`
    },

    clearableDate(item) {
      if (item == 'start') {
        this.date3 = '';
      } else {
        this.date4 = '';
      }
      this.searchData();

    },
    checkStartEnd() {
      if (this.date3 != '' && this.date4 != '') {

        // แปลง string เป็น Date objects
        var startDateObject = new Date(this.date3);
        var endDateObject = new Date(this.date4);

        // เปรียบเทียบวันที่
        if (startDateObject > endDateObject) {
          alert("ข้อความเตือน: วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด")
          this.date3 = ''
          // console.log("ข้อความเตือน: start_date มากกว่า end_date");
        } else if (endDateObject < startDateObject) {
          alert("ข้อความเตือน: วันที่สิ้นสุด น้อยกว่า วันที่สิ้นสุด")
          this.date4 = ''
          // console.log("ข้อความเตือน: end_date น้อยกว่า start_date");
        }
      }
    },
    gotoBR(){
      var url = "/#/erbr/equipment_borrowing_returning"
      window.open(url);
    },

    searchData() {
      this.checkStartEnd();
      this.search_data.start_date = this.date3;
      this.search_data.end_date = this.date4;
      this.getEquipmentListsRequest(this.search_data);
    },
    async beforeMount() {
    },

  },
}
</script>

<style src="../EquipmentBR/EquipmentBR.scss" lang="scss"/>
